import { __ } from '@wordpress/i18n';
import { Component } from 'js-component-framework';
import React from 'react';
import ReactDOM from 'react-dom';

// Components.
import ContentTypeList from './contentTypeList';

/**
 * Component for instantiating the content type list mini-React app.
 */
export default class ContentTypeListWrapper extends Component {
  /**
   * Initialize the component.
   */
  static init() {
    const appElement = document.querySelector('.content-type-list');
    if (appElement) {
      const {
        location: {
          pathname = '',
        } = {},
      } = window;

      // Define post types for use in this component.
      const postTypes = [
        {
          filterable: true,
          label: __('All', 'knight-foundation-app'),
          slug: '',
          type: '',
        },
        {
          filterable: true,
          label: __('Articles', 'knight-foundation-app'),
          slug: 'article',
          type: 'article',
        },
        {
          filterable: true,
          label: __('Reports', 'knight-foundation-app'),
          slug: 'report',
          type: 'report',
        },
        {
          filterable: true,
          label: __('Speeches', 'knight-foundation-app'),
          slug: 'speech',
          type: 'speech',
        },
        {
          filterable: true,
          label: __('Press Mentions', 'knight-foundation-app'),
          slug: 'press-mention',
          type: 'press-mention',
        },
        {
          filterable: true,
          label: __('Press Releases', 'knight-foundation-app'),
          slug: 'press-release',
          type: 'press-release',
        },
        {
          filterable: false,
          label: __('Pages', 'knight-foundation-app'),
          slug: 'pages',
          type: 'page',
        },
        {
          filterable: false,
          label: __('Features', 'knight-foundation-app'),
          slug: 'feature',
          type: 'feature',
        },
      ];

      // Extract the topic slug from the URL.
      // eslint-disable-next-line prefer-destructuring
      let topicSlug = appElement.dataset.topicSlug;

      if (! topicSlug) {
        topicSlug = pathname
          .replace('/topics/', '')
          .replace('/', '');
      }

      if (topicSlug) {
        ReactDOM.render(
          <ContentTypeList
            postTypes={postTypes}
            stepping={4}
            topicSlug={topicSlug}
          />,
          appElement
        );
      }
    }
  }

  /**
   * Start the component.
   *
   * @param {object} config - Configuration for this component.
   */
  constructor(config) {
    super(config);
    this.constructor.init();
  }
}
